import $ from 'jquery'

$(document).ready(dhsv_vc_jobs())

function dhsv_vc_jobs() {}
